/* eslint-disable max-len */
import React from "react";
import { useEdges } from 'reactflow';
import l from "components/util/l";
import { bodyContentMapper } from "components/studio/board/nodes/Node.lib";


function Content({ nodeId, isControl = false, app, action, nodeInput, isSelected, isPreview, onSelectNode }) {

	const nodeValues = nodeInput;
	const appBgColor = app.uiSettings?.base_color ?? "#c7cad0"
	const appFontColor = app.uiSettings?.font_color ?? "#ffffff"
	const displayOptions = action.uiSettings?.node ?? [];
	const formSettings = action.uiSettings.form;

	const title = bodyContentMapper(displayOptions, nodeValues, "title", formSettings);
	const subtitle = bodyContentMapper(displayOptions, nodeValues, "subtitle", formSettings);
	const offsetIconLeft = action.name == "conditional" || action.name == "iterate" ? "6px" : "6px";
	let icon = app.uiSettings?.icon;
	if (action.name == "conditional") icon = "fas fa-diagram-project";
	else if (action.name == "iterate") icon = "fa-solid fa-arrows-rotate";
	else if (action.name == "dummy_node") icon = nodeValues.find(val => val.name == "icon")?.value ?? "fas fa-square";

	// Parent connection position
	const edges = useEdges();
	const sourceEdge = edges.find(edge => edge.target == nodeId);
	let sourcePosition = null;
	if (sourceEdge) sourcePosition = (sourceEdge?.targetHandle ?? "_").split("_")[1].toUpperCase();


	const htmlToPlain = (html) => html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ')

	return (
		<div>

			{/* Node title */}
			{!isControl ? <h6 className="px-2 mb-0 text-center node-title">
				<div>{l(htmlToPlain(title))}</div>
			</h6> : null}

			{/* Node subtitle */}
			<p className="px-2 mb-0 node-subtitle">
				{!isControl && subtitle != "" && (
					<div>{l(htmlToPlain(subtitle))}</div>
				)}

				{/* Main icon for control nodes */}
				{isControl && <i className={`${icon} text-dark`}></i>}
			</p>

			{/* Node subtitle and icon, only apply for control nodes */}
			{isControl && subtitle != "" && (
				<div className="control-node-subtitle"
					style={
						(action.name == "iterate" && sourcePosition == "BOTTOM") ? { right: `calc(100% - ${offsetIconLeft})` } : { left: `calc(100% - ${offsetIconLeft})` }
					}
				>
					<div className="control-node-subtitle-message badge badge-pill badge-light">
						<div dangerouslySetInnerHTML={{ __html: subtitle }} />
					</div>
				</div>
			)}

			{/* Node icon, the icon in the left upper corner */}
			<div className={"node-icon-app " + (isSelected ? "selected " : "") + (!isPreview ? " badge-container" : "")}
				style={{backgroundColor: appBgColor, color: appFontColor}}
				onClick={e => e.stopPropagation()}
			>
				{/* Checkbox used to select the node when mouse is hover */}
				{!isPreview && (
					<div class="badge-checkbox select-node-checkbox" onClick={onSelectNode}>
						<div class="form-group">
							<div class="custom-control custom-checkbox">
								<input type="checkbox" id={`checkSelectNode${nodeId}`} class="custom-control-input"
									onClick={(e) => { e.stopPropagation(); }} checked={isSelected}
								/>
								<label class="custom-control-label" for={`checkSelectNode${nodeId}`}></label>
							</div>
						</div>
					</div>
				)}

				{/* Icon on the left upper corner */}
				{!isControl && (
					<span class="node-icon badge text-center px-0 pb-0 badge-icon">
						<i className={icon}></i>
					</span>
				)}

			</div>

		</div >
	);

}

export default Content;
